import DefaultChip from './DefaultChip';

export default DefaultChip;
